import { Overlay } from 'trading-vue-js';
import Line from './primitives/line.js';

export default {
    name: 'Candles/Bars',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: '',
                version: '',
                desc: /*opt*/ '',
                contact: /*opt*/ '',
                github: /*opt*/ '',
                preset: {
                    name: `Candles/Bars`,
                    side: 'onchart',
                    settings: {
                        showLabel: false,
                        track: true,
                        price: 0,
                        pending: false,
                        pending_type: '',
                        pending_price: 0,
                        pending_value: 0,
                    },
                },
            };
        },
        use_for() {
            return ['Swap'];
        },
        init() {
            this.mouse.on('mousemove', () => {});
        },
        draw(ctx) {
            const layout = this.$props.layout;
            ctx.strokeStyle = this.get_type == 'buy' ? this.buy_color : this.sell_color;
            ctx.fillStyle = this.get_type == 'buy' ? `${this.buy_color}33` : `${this.sell_color}33`;
            ctx.lineWidth = 0.9;
            ctx.beginPath();
            if (this.is_pending && this.pending_type != '') {
                let x = this.mouse.x ? (this.mouse.x > layout.width - 100 ? layout.width - 100 : this.mouse.x) : 50;
                let y = layout.$2screen(this.pending_price);

                if (x != null && y != null) {
                    //new Line(this, ctx).draw([x0, y + 1], [x, y]);
                    ctx.moveTo(0, y);
                    ctx.lineTo(layout.width, y);
                    ctx.strokeStyle = this.pending_type == 'pending-buy' ? this.buy_color : this.sell_color;
                    ctx.fillStyle = this.pending_type == 'pending-buy' ? `${this.buy_color}11` : `${this.sell_color}11`;
                    let text = `${this.pending_type == 'pending-buy' ? 'En haut' : 'En bas'} : ${this.pending_value} €`;
                    ctx.fillRect(0, y, layout.width, this.pending_type == 'pending-buy' ? -layout.height : layout.height);
                    ctx.fillStyle = this.pending_type == 'pending-buy' ? this.buy_color : this.sell_color;
                    ctx.font = '12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(text, x, y - 25);
                }
            } else if (this.show_label && this.mouse_track && this.mouse) {
                let x = this.mouse.x ? this.mouse.x : null;
                let y = this.mouse.y ? this.mouse.y : null;

                if (x != null && y != null) {
                    //new Line(this, ctx).draw([x0, y + 1], [x, y]);
                    ctx.moveTo(0, y);
                    ctx.lineTo(layout.width, y);
                    let text = `${this.get_type == 'buy' ? 'En haut' : 'En bas'} ${this.mouse.y$.toFixed(4)}`;
                    ctx.fillRect(0, y, layout.width, this.get_type == 'buy' ? -layout.height : layout.height);
                    ctx.fillStyle = this.get_type == 'buy' ? this.buy_color : this.sell_color;
                    ctx.font = '12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(text, x, y - 25);
                }
            } else if (this.show_label) {
                let x = this.mouse.x ? this.mouse.x : null;
                let y = layout.$2screen(this.get_price);

                if (x != null && y != null) {
                    //new Line(this, ctx).draw([x0, y + 1], [x, y]);
                    ctx.moveTo(0, y);
                    ctx.lineTo(layout.width, y);
                    let text = `${this.get_type == 'buy' ? 'En haut' : 'En bas'} ${this.mouse.y$.toFixed(4)}`;
                    ctx.fillRect(0, y, layout.width, this.get_type == 'buy' ? -layout.height : layout.height);
                    ctx.fillStyle = this.get_type == 'buy' ? this.buy_color : this.sell_color;
                    ctx.font = '12px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText(text, x, y - 25);
                }
            }
            ctx.stroke();
        },

        mousedown() {
            this.$emit('price-selected', this.mouse.y$);
        },
        legend(values) {
            return [
                {
                    color: `#00000000`, // custom formatter
                },
            ];
        },
        calc() {
            return {
                props: {
                    id: { def: 0, text: 'id' },
                },
                conf: { renderer: 'Spline' },
                update: `                    
                        return 0
                    `,
            };
        },
    },
    settings: {
        showLabel: false,
        track: true,
        price: 0,
        type: '',
        pending: false,
        pending_type: '',
        pending_price: 0,
        pending_value: 0,
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            // Just an alias
            return this.$props.settings;
        },
        buy_color() {
            return this.sett['buyColor'] || '#4CAF50'; // default value
        },
        sell_color() {
            return this.sett['sellColor'] || '#ec4662';
        },
        show_label() {
            return this.sett['showLabel'];
        },
        mouse_track() {
            return this.sett['track'];
        },
        get_type() {
            return this.sett['type'];
        },
        get_price() {
            return this.sett['price'];
        },
        is_pending() {
            return this.sett['pending'];
        },
        pending_type() {
            return this.sett['pending_type'];
        },
        pending_price() {
            return this.sett['pending_price'];
        },
        pending_value() {
            return this.sett['pending_value'];
        },
    },
};
